<template>
  <div class="home">
    <BannerComponent/>
    <CalculatorComponent/>
    <VMAComponent/>
  </div>
</template>

<script>
import BannerComponent from '@/components/BannerComponent.vue'
import CalculatorComponent from '@/components/CalculatorComponent.vue'
import VMAComponent from '@/components/VMAComponent.vue'

export default {
  name: 'HomeView',
  components: {
    BannerComponent,
    CalculatorComponent,
    VMAComponent,
  }
}
</script>
<style scoped>
  .home {
    display: flex;
    flex-direction: column;
  }
</style>
